import { CREATED_THROUGH } from "@hub/plan/src/constants"

export default {
  addNewPlanSvaSelected({ state, commit }, newSva) {
    const NEW_SVAS = [...state.planSvasSelecteds]
    NEW_SVAS.push(newSva)
    commit("setPlanSvasSelecteds", NEW_SVAS)
  },
  changePlanSvaSpecificSelected({ state, commit }, { index, prop, value }) {
    const NEW_SVAS = [...state.planSvasSelecteds]
    NEW_SVAS[index][prop] = value
    commit("setPlanSvasSelecteds", NEW_SVAS)
  },
  deletePlanSvaSelected({ state, commit }, indexToRemove) {
    const NEW_SVAS = [...state.planSvasSelecteds]
    NEW_SVAS.splice(indexToRemove, 1)
    commit("setPlanSvasSelecteds", NEW_SVAS)
  },
  toggleSvasOptionsDisabled({ state, commit }, valueOption) {
    const NEW_OPTIONS = [...state.planSvasOptions]
    const INDEX_OPTION_TO_MODIFY = NEW_OPTIONS.findIndex(
      option => option.value === valueOption
    )
    NEW_OPTIONS[INDEX_OPTION_TO_MODIFY].disabled =
      !NEW_OPTIONS[INDEX_OPTION_TO_MODIFY].disabled
    commit("setPlanSvasOptions", NEW_OPTIONS)
  },

  addNewPlanCampaignSelected({ state, commit }, newCampaign) {
    const NEW_CAMPAIGNS = [...state.planCampaignSelecteds]
    NEW_CAMPAIGNS.push(newCampaign)
    commit("setPlanCampaignSelecteds", NEW_CAMPAIGNS)
  },
  deletePlanCampaignSelected({ state, commit }, indexToRemove) {
    const NEW_CAMPAIGNS = [...state.planCampaignSelecteds]
    NEW_CAMPAIGNS.splice(indexToRemove, 1)
    commit("setPlanCampaignSelecteds", NEW_CAMPAIGNS)
  },
  togglePlanCampaignOptionsDisabled({ state, commit }, valueOption) {
    const NEW_OPTIONS = [...state.planCampaignOptions]
    const INDEX_OPTION_TO_MODIFY = NEW_OPTIONS.findIndex(
      option => option.value === valueOption
    )
    NEW_OPTIONS[INDEX_OPTION_TO_MODIFY].disabled =
      !NEW_OPTIONS[INDEX_OPTION_TO_MODIFY].disabled
    commit("setPlanCampaignOptions", NEW_OPTIONS)
  },

  fillPlanEditing({ state, commit }, plan) {
    commit("setPlanName", plan.name)
    commit("setPlanCommercialName", plan.trade_name)
    commit("setPlanCategorySelected", plan.service_type.uuid)
    commit("setPlanPrice", plan.value)
    if (plan.movements.length) {
      const movements = plan.movements.map(movement => movement.uuid)
      commit("setPlanMovementSelected", movements)
    }
    commit("setPlanScore", plan.score)
    commit("setPlanPhysicalPerson", plan.physical_marketable)
    commit("setPlanLegalPerson", plan.legal_marketable)
    commit("setPlanActive", plan.active)
    commit("setPlanRecommended", plan.highlighted)
    commit("setPlanShouldBeDisplayed", plan.marketable)

    commit("setPlanCreatedThrough", plan.created_through || CREATED_THROUGH.INTEGRATION)

    if (plan.icon) {
      commit("setPlanIconPreview", { url: plan.icon, icon: "" })
    }

    commit("setPlanRelatedPackages", plan.related_packages)

    commit(
      "setPlanSvasSelecteds",
      plan.services.map(service => ({
        icon: service.icon || null,
        name: service.name,
        value: service.uuid,
        text: service.name,
        price: service.value,
        fixed: Boolean(service.fixed),
        included: Boolean(service.included)
      }))
    )
    commit(
      "setPlanCampaignSelecteds",
      plan.campaigns.map(campaign => ({
        ...campaign,
        text: campaign.name,
        value: campaign.uuid
      }))
    )
    commit(
      "setPlanCoverageStatesSelecteds",
      plan.states.map(state => ({
        text: state.name,
        value: state.id,
        price: state.value,
        uuid: state.id
      }))
    )
    commit(
      "setPlanCoverageCitySelecteds",
      plan.cities.map(city => ({
        text: city.name,
        value: city.uuid,
        price: city.value,
        state: city.state
      }))
    )
    commit(
      "setPlanCoverageDddsSelecteds",
      plan.area_codes.map(areaCode => ({
        text: areaCode.code,
        value: areaCode.uuid,
        price: areaCode.value
      }))
    )
    commit(
      "setPlanAccessChainsSelecteds",
      plan.chains.map(chain => ({
        text: chain.name,
        value: chain.uuid
      }))
    )
    commit(
      "setPlanAccessPosSelecteds",
      plan.pos.map(p => ({
        text: p.name,
        value: p.uuid
      }))
    )
    commit(
      "setPlanDiscountPaymentSelecteds",
      plan.discounts.payment.map(payment => ({
        type: payment.criteria,
        text: payment.type_name,
        value: payment.type,
        price: payment.value
      }))
    )
    commit(
      "setPlanDiscountShippingSelecteds",
      plan.discounts.shipping.map(shipping => ({
        type: shipping.criteria,
        text: shipping.type_name,
        value: shipping.type,
        price: shipping.value
      }))
    )

    commit("setHasAdditionalConfig", Boolean(plan.addon?.active))
    commit("setFreeAdditionalQuantity", plan.addon?.free_quantity ?? 0)
    commit("setPaidAdditionalQuantity", plan.addon?.paid_quantity ?? 0)
    commit("setAdditionalUnitPrice", plan.addon?.unit_price ?? null)
  }
}
